/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Knp_Guide_Delete_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{title}\"? This will also delete all terms." |
*
* @param {Knp_Guide_Delete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_delete_text = /** @type {((inputs: Knp_Guide_Delete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Delete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer « ${i?.title} » ? Cela supprimera aussi tous les termes.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.title}" wirklich löschen? Dadurch werden auch alle Einträge gelöscht.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Vuoi davvero eliminare "${i?.title}"? Verranno eliminati anche tutti i termini.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить "${i?.title}"? Это также удалит все термины.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Seguro que desea eliminar "${i?.title}"? Esto también eliminará todos los términos.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要删除“${i?.title}”吗？这将同时删除所有相关术语。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.title}」を削除してもよろしいですか？これにより、すべての用語も削除されます。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.title}" को हटाना चाहते हैं? इससे सभी शब्द भी हट जाएंगे।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir "${i?.title}"? Isso também excluirá todos os termos.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.title}"? This will also delete all terms.`)
});